import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import { Close } from "@mui/icons-material";
import CheckIcon from '@mui/icons-material/Check';
import { useMediaQuery, useTheme } from "@mui/material";

const WhyNeuroid = () => {
    const theme = useTheme();
    const isBig = useMediaQuery(theme.breakpoints.down(1250));
    const isMobile = useMediaQuery(theme.breakpoints.down(890));


    const styles = {
        container: {
            flex: 1,
            backgroundColor: '#000',
            color: '#fff',
            paddingTop: 8,
            boxSizing: 'border-box',
            paddingBottom: 8
        },
        stepContainer: {
            display: "flex",
            alignItems: "center",
            gap: "20px",
            position: "relative",
        },
        timeline: {
            position: "absolute",
            left: "10px",
            width: "2px",
            height: "100%",
            backgroundColor: "#FFC107",
            zIndex: -1,
        },
        stepNumber: {
            width: "30px",
            height: "30px",
            borderRadius: "50%",
            backgroundColor: "#FFC107",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "bold",
            color: "#fff",
        },
        card: {
            width: "400px",
            border: "1px solid #ddd",
            borderRadius: "10px",
            boxShadow: "3px 3px 10px rgba(0,0,0,0.1)",
            padding: "10px",
        },
        stepLabel: {
            fontWeight: "bold",
            backgroundColor: "#000",
            color: "#fff",
            display: "inline-block",
            padding: "5px 10px",
            borderRadius: "5px",
            marginBottom: "10px",
        },
        iconBox: {
            borderRadius: '50%',
            backgroundColor: 'red',
            width: '20px',
            height: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        greenIconBox: {
            borderRadius: '50%',
            backgroundColor: 'green',
            width: '20px',
            height: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        icon: {
            fontSize: 15,
            fontWeight: 'bold',
            color: 'white'
        },
    };


    return (
        <Box sx={styles.container}>
            <Box sx={{ width: '100%' }}>
                <Typography variant={isMobile ? "h5" : "h3"} textAlign={"center"} fontWeight="bold" mb={2} mt={4}>
                    Why <span style={{ color: 'rgb(255, 210, 48)'}}>GroMedia</span> Over Others?
                </Typography>
                <Typography variant="body1" textAlign={"center"} sx={{ width: isMobile ? '90%' : isBig ? '60%' : '35%', margin: '0px auto', fontSize: isMobile ? '15px' : '18px' }}>
                    In the large pool of top promises, GroMedia is your growth partner that believes  more in execution & real results.
                </Typography>
            </Box>


            <Box style={{ width: isMobile ? '95%' : isBig ? '90%' : '80%', margin: '0px auto', marginTop: 80, display: 'flex', flexDirection: isMobile ? 'column' : 'row',gap: 20, justifyContent: 'space-between' }}>
                <Box style={{ width: isMobile ? '100%' :  '48%', border: '2px dashed red', padding: '50px', boxSizing: 'border-box', borderRadius: '20px' }}>
                    <Box
                        sx={{
                            position: "relative",
                            display: "inline-block",
                            fontSize: "32px",
                            fontWeight: "bold",
                            color: "white",
                            background: "black",
                            padding: "10px 20px",
                            "&::before, &::after": {
                                content: '""',
                                position: "absolute",
                                width: "100%",
                                height: "4px",
                                backgroundColor: "red",
                                top: "50%",
                                left: "-10%",
                                transformOrigin: "center",
                            },
                            "&::before": {
                                transform: "rotate(20deg)", // Slanted from left to right
                            },
                            "&::after": {
                                transform: "rotate(-20deg)", // Slanted from right to left
                            },
                        }}
                    >
                        Other Agencies
                    </Box>

                    <Box style={{ marginTop: 50, display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={styles.iconBox}>
                            <Close sx={styles.icon} />
                        </div>

                        <div>
                            Traditional Ads Agency or Creative Agency
                        </div>
                    </Box>

                    <Box style={{ marginTop: 15, display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={styles.iconBox}>
                            <Close sx={styles.icon} />
                        </div>

                        <div>
                            Long Contracts
                        </div>
                    </Box>


                    <Box style={{ marginTop: 15, display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={styles.iconBox}>
                            <Close sx={styles.icon} />
                        </div>

                        <div>
                            Specific Tool Experts (Facebook, Google)
                        </div>
                    </Box>


                    <Box style={{ marginTop: 15, display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={styles.iconBox}>
                            <Close sx={styles.icon} />
                        </div>

                        <div>
                            Testing done at your expenses
                        </div>
                    </Box>

                    <Box style={{ marginTop: 15, display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={styles.iconBox}>
                            <Close sx={styles.icon} />
                        </div>

                        <div>
                            Over-Professional on Communication
                        </div>
                    </Box>

                    <Box style={{ marginTop: 15, display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={styles.iconBox}>
                            <Close sx={styles.icon} />
                        </div>

                        <div>
                            No Industry experience
                        </div>
                    </Box>
                </Box>
                <Box style={{ width: isMobile ? '100%' : '48%', border: '2px dashed green', padding: '50px', boxSizing: 'border-box', borderRadius: '20px' }}>
                    <Box
                        sx={{
                            position: "relative",
                            display: "inline-block",
                            fontSize: "32px",
                            fontWeight: "bold",
                            color: "white",
                            background: "black",
                            padding: "10px 20px",
                            "& .underline": {
                                position: "absolute",
                                left: "5%",
                                width: "90%",
                                height: "5px",
                                backgroundColor: "lightgreen",
                                borderRadius: "5px",
                                transform: "skewX(-10deg)",
                            },
                            "& .underline.first": {
                                bottom: "-5px",
                            },
                            "& .underline.second": {
                                bottom: "-12px",
                            },
                        }}
                    >
                        GroMedia Agency
                        <span className="underline first"></span>
                        <span className="underline second"></span>
                    </Box>

                    <Box style={{ marginTop: 50, display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={styles.greenIconBox}>
                            <CheckIcon sx={styles.icon} />
                        </div>

                        <div>
                            Your eCommerce Growth Partner
                        </div>
                    </Box>

                    <Box style={{ marginTop: 15, display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={styles.greenIconBox}>
                            <CheckIcon sx={styles.icon} />
                        </div>

                        <div>
                            Month-on-Month Contracts
                        </div>
                    </Box>

                    <Box style={{ marginTop: 15, display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={styles.greenIconBox}>
                            <CheckIcon sx={styles.icon} />
                        </div>

                        <div>
                            CEO runs his own brand
                        </div>
                    </Box>

                    <Box style={{ marginTop: 15, display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={styles.greenIconBox}>
                            <CheckIcon sx={styles.icon} />
                        </div>

                        <div>
                            Marketing & Psychology Geeks
                        </div>
                    </Box>

                    <Box style={{ marginTop: 15, display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={styles.greenIconBox}>
                            <CheckIcon sx={styles.icon} />
                        </div>

                        <div>In-House Like Communication</div>
                    </Box>

                    <Box style={{ marginTop: 15, display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={styles.greenIconBox}>
                            <CheckIcon sx={styles.icon} />
                        </div>

                        <div>
                            Proven & tested strategies
                        </div>
                    </Box>
                </Box>
            </Box>
        </Box >
    );
};

export default WhyNeuroid;
